import React, { useEffect, useState } from "react";
import { Navbar, Row, Image, OverlayTrigger, Popover } from "react-bootstrap";
import { List } from "react-bootstrap-icons";
import { useMsal } from "@azure/msal-react";
import { userlogo } from "../../helpers/formatter";
import { secureLogout } from "../../helpers/tokenSecurity";
import logoutarrow from "../../assets/logoutarrow.svg"

export default function Header(props) {
  const { instance } = useMsal();

  async function handleLogout(instance) {
    await secureLogout(instance);
  }

  const colors = ['#d9e3ee', '#f3d7d7', '#ebe4d5', '#d7f4f4', '#e0d5f1'];
  const fontcolors = ['#1A78E5', '#C64441', '#EDA70E', '#23B3B3', '#5D00F8'];
  const [randomColor, setRandomColor] = useState('');
  const [randomFontColor, setRandomFontColor] = useState('');

  useEffect(() => {
    const assignColor = crypto.getRandomValues(new Uint32Array(1))[0] % colors.length;
    const selectedColor = colors[assignColor];
    setRandomColor(selectedColor);
    const findFontColor = colors.findIndex(el => el === selectedColor);
    const selectedFontColor = fontcolors[findFontColor];
    setRandomFontColor(selectedFontColor);
  }, []);

  const logoStyle = {
    // background: `${randomColor} 0% 0% no-repeat padding-box`,
    color: `${randomFontColor}`
  };

  return (
    <>
      <Navbar bsPrefix="header">
        <div className="sidebar-head-header">
          <List className="head-toggle" onClick={() => { props.setSidebar(props.sidebar === "closed" ? "open" : "closed") }}></List>
        </div>
        <div className="app-name">Godrej Consumer Finance</div>
        <div className="user-section">
          <OverlayTrigger trigger="click" placement="bottom-end" rootClose overlay={
            <Popover className="profile"
              aria-labelledby="contained-modal-title-vcenter"
            >
              <div className="user-section">
                <div className="user-logo" style={logoStyle}>
                  {userlogo(sessionStorage.getItem("UserName"))}
                </div>
                <div className="user-info">
                  <Row>
                    <span className="user-name">{sessionStorage.getItem("UserName")}</span>
                  </Row>
                  <Row>
                    <span className="user-email">{sessionStorage.getItem("Email")} </span>
                  </Row>
                </div>
                <Image src={logoutarrow} onClick={(e) => handleLogout(instance)}></Image>

              </div>
            </Popover>}>
            <div className="user-logo" style={logoStyle}>
              {userlogo(sessionStorage.getItem("UserName"))}
            </div>
          </OverlayTrigger>
        </div>
      </Navbar>

    </>
  );
}
